"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WaitingOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M13 11a3.19 3.19 0 003 3 3.19 3.19 0 003-3z"/><path d="M27 28h-1.17c-.67-4.48-3.27-10.5-5.8-12 2.53-1.5 5.13-7.52 5.8-12H27a1 1 0 000-2H5a1 1 0 000 2h1.17C6.84 8.48 9.44 14.5 12 16c-2.53 1.5-5.13 7.52-5.8 12H5a1 1 0 000 2h22a1 1 0 000-2zm-5 0c0-3-4.5-7-6-7s-6 4-6 7H8.18c.67-4 3-9.2 4.81-10.28a2 2 0 000-3.44C11.17 13.2 8.85 8 8.18 4h15.64c-.67 4-3 9.2-4.81 10.28a2 2 0 000 3.44C20.83 18.8 23.15 24 23.82 28z"/>';
var WaitingOutlineSVG = function WaitingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WaitingOutlineSVG = WaitingOutlineSVG;
WaitingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WaitingOutlineSVG);
exports.default = _default;